/**
 * Label for the location link on product cards / cart / PDP.
 * Multi-location uses "More Locations"; otherwise "Change Location".
 */
export const getLocationLinkLabelKey = (
  isMultiLocationEnabled: boolean
): 'moreLocations' | 'changeLocation' => {
  if (isMultiLocationEnabled) return 'moreLocations'
  return 'changeLocation'
}
